import { Component, Input, ViewEncapsulation } from "@angular/core";
import { TranslationService } from "../../_services/translation.service";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../_models/ITranslations";

@Component({
  selector: "form-field-error",
  template: `
    <div class="form-field-error">
      <span class="async-validation-icon-error">
        <img src="../../../assets/svg/form-error-icon.svg" alt="error" />
      </span>
      <span class="form-error-message">
        {{ _message }}
      </span>
    </div>
  `,
  styleUrls: ["./form-field-error.component.scss"],
})
export class FormFieldErrorComponent {
  public translations$: Observable<ITranslations>;

  constructor(private translationService: TranslationService) {
    this.translations$ = this.translationService.translations;
  }

  public _show: boolean;

  @Input() public set show(value: boolean) {
    if (value) {
      this._show = value;
    }
  }

  public _message: string;

  @Input() public set message(value: string) {
    if (value) {
      this._message = value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/form-field-error/form-field-error.component.ts